class SuperposterHoverMenu {
  constructor() {
    this.mediaQuery = window.matchMedia('(min-width: 990px)');
    this.items = document.querySelectorAll('.header__inline-menu header-menu > details');
    this.bindEvents();
  }

  bindEvents() {
    this.items.forEach((details) => {
      let closeTimer;

      details.addEventListener('mouseenter', () => {
        if (!this.mediaQuery.matches) return;

        window.clearTimeout(closeTimer);
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', () => {
        if (!this.mediaQuery.matches) return;

        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 220);
      });

      details.addEventListener('focusout', () => {
        if (!this.mediaQuery.matches) return;

        window.setTimeout(() => {
          if (!details.contains(document.activeElement) && !details.matches(':hover')) {
            details.removeAttribute('open');
          }
        }, 0);
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SuperposterHoverMenu();

  const formatMoney = (amount) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    const numericAmount = Number(amount || 0) / 100;

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format(numericAmount);
  };

  const refreshSlidingTags = () => {
    document.querySelectorAll('.superposter-product-card__tags').forEach((tags) => {
      const track = tags.querySelector('.superposter-product-card__tags-track');

      if (!track) return;

      const overflow = Math.max(0, track.scrollWidth - tags.clientWidth);
      tags.classList.toggle('is-overflowing', overflow > 6);
      tags.style.setProperty('--sp-tag-shift', `-${overflow}px`);
    });
  };

  refreshSlidingTags();
  window.addEventListener('resize', refreshSlidingTags);

  document.querySelectorAll('[data-superposter-collection-search]').forEach((input) => {
    const page = input.closest('.superposter-collection-page');
    const cards = [...page.querySelectorAll('[data-superposter-product-card]')];
    const countNode = page.querySelector('[data-superposter-filter-count]');
    const emptyNode = page.querySelector('[data-superposter-filter-empty]');
    const tagResults = page.querySelector('[data-superposter-tag-results]');
    const allTags = (tagResults?.dataset.tags || '')
      .split('||')
      .map((tag) => tag.trim())
      .filter(Boolean);

    const renderTags = (keyword) => {
      if (!tagResults) return;

      tagResults.innerHTML = '';

      if (!keyword) return;

      allTags
        .filter((tag) => tag.toLowerCase().includes(keyword))
        .slice(0, 20)
        .forEach((tag) => {
          const button = document.createElement('button');
          button.className = 'superposter-tag-chip';
          button.type = 'button';
          button.textContent = tag;
          button.addEventListener('click', () => {
            input.value = tag;
            input.dispatchEvent(new Event('input', { bubbles: true }));
          });
          tagResults.append(button);
        });
    };

    input.addEventListener('input', () => {
      const keyword = input.value.trim().toLowerCase();
      let visibleCount = 0;

      cards.forEach((card) => {
        const matches = !keyword || (card.dataset.search || '').includes(keyword);
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (countNode) countNode.textContent = `${visibleCount} posters`;
      if (emptyNode) emptyNode.hidden = visibleCount > 0;

      renderTags(keyword);
      refreshSlidingTags();
    });
  });

  document.querySelectorAll('.superposter-product-form').forEach((productForm) => {
    const form = productForm.querySelector('form');
    const variantIdInput = productForm.querySelector('[data-superposter-variant-id]');
    const variantsScript = productForm.querySelector('[data-superposter-variants]');
    const variantMediaScript = productForm.querySelector('[data-superposter-variant-media]');
    const addButton = productForm.querySelector('[data-superposter-add-button]');
    const priceRow = productForm.closest('.superposter-product-info')?.querySelector('.superposter-price-row');
    const productPage = productForm.closest('.superposter-product-page');
    const mainImage = productPage?.querySelector('[data-superposter-main-media] img');

    if (!form || !variantIdInput || !variantsScript) return;

    let variants = [];

    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    let variantMedia = [];

    try {
      variantMedia = JSON.parse(variantMediaScript?.textContent || '[]');
    } catch (error) {
      variantMedia = [];
    }

    const selectedOptions = () =>
      [...productForm.querySelectorAll('.superposter-option-group')].map((group) => {
        const selected = group.querySelector('[data-option-value]:checked');
        return selected ? selected.value : '';
      });

    const updateVariant = () => {
      const options = selectedOptions();
      const matchedVariant = variants.find((variant) =>
        options.every((value, index) => variant.options[index] === value)
      );

      productForm.querySelectorAll('.superposter-option-group').forEach((group) => {
        const selected = group.querySelector('[data-option-value]:checked');
        const selectedValue = group.querySelector('[data-selected-option-value]');

        if (selected && selectedValue) selectedValue.textContent = selected.value;
      });

      if (!matchedVariant) {
        variantIdInput.disabled = true;
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
        }
        return;
      }

      variantIdInput.value = matchedVariant.id;
      variantIdInput.disabled = !matchedVariant.available;

      if (addButton) {
        addButton.disabled = !matchedVariant.available;
        addButton.textContent = matchedVariant.available ? 'Add to cart' : 'Sold out';
      }

      if (priceRow) {
        const price = priceRow.querySelector('strong');
        const compareAt = priceRow.querySelector('s');

        if (price) price.textContent = formatMoney(matchedVariant.price);
        if (compareAt) {
          compareAt.textContent = matchedVariant.compare_at_price ? formatMoney(matchedVariant.compare_at_price) : '';
          compareAt.hidden = !matchedVariant.compare_at_price;
        }
      }

      const matchedMedia = variantMedia.find((media) => String(media.id) === String(matchedVariant.id));

      if (mainImage && matchedMedia?.src) {
        mainImage.src = matchedMedia.src;
        if (matchedMedia.srcset) mainImage.srcset = matchedMedia.srcset;
        mainImage.alt = matchedMedia.alt || mainImage.alt;
      }
    };

    productForm.querySelectorAll('[data-option-value]').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    updateVariant();
  });

  document.addEventListener('click', (event) => {
    const minusButton = event.target.closest('[data-superposter-qty-minus]');
    const plusButton = event.target.closest('[data-superposter-qty-plus]');

    if (!minusButton && !plusButton) return;

    const stepper = event.target.closest('.superposter-quantity-stepper');
    const input = stepper ? stepper.querySelector('input[name="quantity"]') : null;

    if (!input) return;

    const currentValue = Number.parseInt(input.value, 10) || 1;
    const minimum = Number.parseInt(input.getAttribute('min'), 10) || 1;
    const nextValue = plusButton ? currentValue + 1 : Math.max(minimum, currentValue - 1);

    input.value = String(nextValue);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
